import styles from './index.less';

export default ({ title }: any) => {
  return (
    <div className={styles.breadCrumb}>
      <div>
        当前位置：
        {/* 当前位置： */}
        <i
          data-a-href="/"
          onClick={() => {
            window.open('/');
          }}
        >
          京东健康
        </i>
        <span>{">"}</span>
        <span>{title}</span>
      </div>
    </div>
  )
}